import { useNavigate } from 'react-router-dom'

import { Layout } from '@/modules/shared/layouts/layout'

import { useReleaseNote } from '../hooks/use-release-note.hook'
import { ReleaseNotesInterface } from '../interfaces/release-notes.interface'

export function ReleaseNotesContainer() {
  const navigate = useNavigate()
  const releaseNotesHook = useReleaseNote()
  return (
    <Layout pageTitle="Notas de Atualização" handleGoBack={() => navigate('/')}>
      <ReleaseNotesInterface {...releaseNotesHook} />
    </Layout>
  )
}
